import { MockPolicyId } from "../mockPolicies";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { getMockPolicies } from "../builders/getMockPolicies";

import { MockPersona } from "./mockPersonas.types";

const canadianPolicies: MockPolicyId[] = ["dc101", "dc102"];

export const markNobroker: MockPersona = {
  key: "markNobroker",
  name: "Mark Nobroker",
  // Note: Canada has no HDC 1.0 AAA. If that ever changes, update this user to have it.
  description: "🇨🇦 | Multiple policies with no broker | No HDC | ESign alert",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: getMockPolicies(...canadianPolicies),
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB0" }),
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "QC" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "mark@nobroker.com",
            firstName: "Mark",
            middleName: "",
            lastName: "Nobroker",
            mailingAddress: {
              line1: "54 Erie Dr",
              line2: "",
              city: "Montreal",
              state: "QC",
              postalCode: "G1A 0A6",
              country: "CANADA",
            },
            preferredPhone: "5145551212",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000020",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: undefined,
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
